import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    initialConfiguration: {},
    configuration: {},
    customer: {},
    initialCustomerConfiguration: {},
    customerAssets: {},
    initialCustomerAssets: {},
    companyConfiguration: {},
    initialCompanyConfiguration: {},
}

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInitialConfiguration: (state, { payload }) => {
      return { ...state, initialConfiguration: payload }
    },
    setUserConfiguration: (state, { payload }) => {
      return { ...state, configuration: payload }
    },
    setLanguage: (state, { payload }) => {
      return { ...state, configuration: { ...state.configuration, language: payload } }
    },
    setCustomerConfiguration: (state, { payload }) => {
      return { ...state, customer: payload }
    },
    setInitialCustomerConfiguration: (state, { payload }) => {
      return { ...state, initialCustomerConfiguration: payload }
    },
    setCustomerAssets: (state, { payload }) => {
      return { ...state, customerAssets: payload }
    },
    setInitialCustomerAssets: (state, { payload }) => {
      return { ...state, initialCustomerAssets: payload }
    },
    setUsersCompanyConfiguration: (state, { payload }) => {
      return { ...state, companyConfiguration: payload }
    },
    setUsersInitialCompanyConfiguration: (state, { payload }) => {
      return { ...state, initialCompanyConfiguration: payload }
    },
    clearState: () => initialState
  },
})

const { reducer, actions } = slice

export const {
  setUserInitialConfiguration,
  setUserConfiguration,
  setLanguage,
  setCustomerConfiguration,
  setInitialCustomerConfiguration,
  setCustomerAssets,
  setInitialCustomerAssets,
  setUsersCompanyConfiguration,
  setUsersInitialCompanyConfiguration,
  clearState
} = actions

export default reducer
